import { render } from "./DDMessages.vue?vue&type=template&id=1f0e6a6b"
import script from "./DDMessages.vue?vue&type=script&lang=js"
export * from "./DDMessages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__